import Person from "./Person";

export default class PersonItemQuantity extends Person {
  preposalId;
  itemId;
  quantity;

  constructor(preposalId, itemId, quantity) {
    super();

    this.preposalId = preposalId;
    this.itemId = itemId;
    this.quantity = quantity;
  }

  process(cart, productBySku) {
    var item = cart.items.find(item => item.id == this.itemId);
    item.quantity = this.quantity;
    item.loading = true;
  }
  toDto() {
    return {
      spa_passenger_dto_type: "item-quantity",
      spa_passenger_dto_item_quantity: {
        spa_passenger_item_quantity_dto_preposal_id: this.preposalId,
        spa_passenger_item_quantity_dto_item_id: this.itemId,
        spa_passenger_item_quantity_dto_quantity: this.quantity
      }
    }
  }
}